/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs */

const en_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing and keyword optimization`)
};

const ar_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحسين القوائم والكلمات المفتاحية`)
};

const bn_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিস্টিং ও কীওয়ার্ড অপ্টিমাইজেশন`)
};

const de_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing- und Keyword-Optimierung`)
};

const es_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimización de anuncios y palabras clave`)
};

const fr_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisation d'annonces et de mots-clés`)
};

const pt_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otimização de anúncios e palavras-chave`)
};

const zh_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing 与关键词优化`)
};

const tr_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listeleme ve anahtar kelime optimizasyonu`)
};

const ru_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оптимизация листингов и ключей`)
};

const pl_svc_ecommerce_amazon_tools_listings_title8 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optymalizacja listingów i słów kluczowych`)
};

/**
* | output |
* | --- |
* | "Listing and keyword optimization" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_listings_title8 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Listings_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_listings_title8(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_listings_title8(inputs)
	return en_svc_ecommerce_amazon_tools_listings_title8(inputs)
});
export { svc_ecommerce_amazon_tools_listings_title8 as "svc_ecommerce-amazon-tools_LISTINGS_title" }